module.exports = __webpack_public_path__ + "pc/img/swiper_logo_lgU.9083feab.png";